// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as IconPlusBold$Showside from "../icons/IconPlusBold.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as IconMinusBold$Showside from "../icons/IconMinusBold.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as TruncatedContainer$Showside from "./TruncatedContainer.bs.js";
import * as ProductDetailsConfig$Showside from "../types/ProductDetailsConfig.bs.js";
import * as ProductDetailsConfigId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ProductDetailsConfigId.bs.js";
import SmoothScrollIntoViewIfNeeded from "smooth-scroll-into-view-if-needed";
function makeSection(titleOpt, id, children, renderer, collapsible, separator, padding, unit) {
  var title = titleOpt !== undefined ? titleOpt : {
    TAG: /* Element */1,
    _0: null
  };
  return {
    title: title,
    id: id,
    children: children,
    renderer: Belt_Option.getWithDefault(renderer, function (a) {
      return a;
    }),
    collapsible: Belt_Option.getWithDefault(collapsible, false),
    separator: Belt_Option.getWithDefault(separator, false),
    padding: Belt_Option.getWithDefault(padding, true)
  };
}
function fromDetailedSections(detailedSections, product, variant, config) {
  return Belt_Array.keepMap(Belt_Array.mapWithIndex(detailedSections, function (i, section) {
    var children = ProductDetailsConfig$Showside.DetailedSection.renderContents(undefined, product, variant, config, section);
    var match = section.accordionState;
    var collapsible = match ? false : true;
    if (children.length !== 0) {
      return makeSection({
        TAG: /* Text */0,
        _0: section.title
      }, Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, section.id), Caml_option.some(children), undefined, collapsible, i !== 0, undefined, undefined);
    }
  }), function (a) {
    return a;
  });
}
function getTitleClass(titleStyle, titleSize) {
  return Cn.make([titleStyle === "semibold-uppercase" ? "text-primary font-semibold uppercase" : titleStyle === "semibold" ? "text-tertiary font-semibold" : titleStyle === "medium" ? "text-primary font-medium" : titleStyle === "normal" ? "text-primary font-normal" : "text-primary font-semibold", titleSize === "small" ? "text-lg" : "text-xl"]);
}
function Accordion$Header(Props) {
  var active = Props.active;
  var id = Props.id;
  var classNameOpt = Props.className;
  var tabIndexOpt = Props.tabIndex;
  var titleStyleOpt = Props.titleStyle;
  var titleSizeOpt = Props.titleSize;
  var children = Props.children;
  var contentRight = Props.contentRight;
  var onClickOpt = Props.onClick;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : -1;
  var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold-primary";
  var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
  var onClick = onClickOpt !== undefined ? onClickOpt : function (param) {};
  var titleClassName = getTitleClass(titleStyle, titleSize);
  var ref = React.useRef(null);
  var handleClick = function (e) {
    Curry._1(onClick, e);
    setTimeout(function (param) {
      var el = ref.current;
      if (!(el == null)) {
        SmoothScrollIntoViewIfNeeded(el, {
          behavior: "instant",
          block: "nearest",
          inline: "nearest",
          scrollMode: "if-needed"
        });
        return;
      }
    }, 0);
  };
  return React.createElement(DataAttribute$Showside.make, {
    dataActive: active === id,
    dataTestId: "pdp-accordion-title",
    ariaExpanded: active === id,
    children: React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(ref),
      "aria-controls": id,
      className: className,
      role: "button",
      tabIndex: tabIndex,
      onClick: handleClick
    }, Caml_obj.notequal(children, null) ? React.createElement("div", {
      className: CSS$Showside.prefix("flex items-center")
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex-grow font-heading", titleClassName]))
    }, children), contentRight !== undefined ? React.createElement("div", {
      className: CSS$Showside.prefix("pr-1 pl-2")
    }, Caml_option.valFromOption(contentRight)) : null) : null)
  });
}
Accordion$Header.displayName = "Accordion.Header";
var Header = {
  make: Accordion$Header
};
function Accordion$Section(Props) {
  var index = Props.index;
  var section = Props.section;
  var onExpand = Props.onExpand;
  var onCollapse = Props.onCollapse;
  var active = Props.active;
  var titleStyleOpt = Props.titleStyle;
  var titleSizeOpt = Props.titleSize;
  var forceCollapsibleOpt = Props.forceCollapsible;
  var inlineOpt = Props.inline;
  var truncated = Props.truncated;
  var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold-primary";
  var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
  var forceCollapsible = forceCollapsibleOpt !== undefined ? forceCollapsibleOpt : false;
  var inline = inlineOpt !== undefined ? inlineOpt : false;
  var match = React.useState(function () {
    return true;
  });
  var setOpen = match[1];
  var isOpen = match[0];
  React.useEffect(function () {
    Curry._1(setOpen, function (param) {
      if (section.collapsible) {
        return active === section.id;
      } else {
        return true;
      }
    });
  }, [active]);
  var onClick = function (param) {
    if (section.collapsible) {
      if (isOpen) {
        return Curry._1(onCollapse, undefined);
      } else {
        return Curry._1(onExpand, undefined);
      }
    }
  };
  var match$1 = section.padding;
  var content = React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["text-secondary text-lg", section.collapsible ? "overflow-hidden" : "", isOpen ? "" : forceCollapsible ? "h-0" : "truncate-lines line-clamp-2"]))
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([titleSize === "small" ? "" : titleStyle === "semibold-primary" ? match$1 ? "pb-10" : "" : match$1 ? "pb-2" : "", inline ? "flex" : ""]))
  }, Belt_Option.getWithDefault(section.children, null)));
  var content$1 = truncated ? React.createElement(TruncatedContainer$Showside.make, {
    children: content
  }) : content;
  var icon = isOpen ? React.createElement(IconMinusBold$Showside.make, {
    className: CSS$Showside.prefix(Cn.make(["text-primary w-4 h-4"]))
  }) : React.createElement(IconPlusBold$Showside.make, {
    className: CSS$Showside.prefix(Cn.make(["text-primary w-4 h-4"]))
  });
  var icon$1 = section.collapsible ? icon : null;
  var cursorClass = section.collapsible ? "cursor-pointer" : "";
  var tabIndex = section.collapsible ? 0 : -1;
  var paddingClass = Caml_obj.equal(section.title, {
    TAG: /* Element */1,
    _0: null
  }) || Caml_obj.equal(section.title, {
    TAG: /* Text */0,
    _0: ""
  }) ? "" : titleSize === "small" ? "pb-2" : titleStyle === "semibold-primary" ? "py-10" : "py-4";
  var el = section.children;
  if (el === undefined) {
    return null;
  }
  var text = section.title;
  var tmp;
  tmp = text.TAG === /* Text */0 ? text._0 : undefined;
  var tmp$1 = {
    key: section.id,
    className: CSS$Showside.prefix("flex-shrink-0"),
    id: section.id,
    role: "region"
  };
  if (tmp !== undefined) {
    tmp$1["aria-label"] = Caml_option.valFromOption(tmp);
  }
  var element = section.title;
  var tmp$2;
  tmp$2 = element._0;
  return Curry._1(section.renderer, React.createElement(React.Fragment, undefined, section.separator && index > 0 ? React.createElement("div", {
    className: CSS$Showside.prefix("border-t border-primary opacity-5 h-0")
  }) : null, React.createElement(DataAttribute$Showside.make, {
    dataSectionId: section.id,
    children: React.createElement("div", tmp$1, React.createElement(Accordion$Header, {
      active: active,
      id: section.id,
      className: CSS$Showside.prefix(Cn.make([paddingClass, cursorClass])),
      tabIndex: tabIndex,
      titleStyle: titleStyle,
      titleSize: titleSize,
      children: tmp$2,
      contentRight: icon$1,
      onClick: onClick
    }), content$1)
  })));
}
Accordion$Section.displayName = "Accordion.Section";
var Section = {
  make: Accordion$Section
};
function Accordion(Props) {
  var id = Props.id;
  var sections = Props.sections;
  var onChangeFocusOpt = Props.onChangeFocus;
  var classNameOpt = Props.className;
  var titleStyleOpt = Props.titleStyle;
  var titleSizeOpt = Props.titleSize;
  var inlineOpt = Props.inline;
  var truncated = Props.truncated;
  var forceCollapsibleOpt = Props.forceCollapsible;
  var active = Props.active;
  var onChangeFocus = onChangeFocusOpt !== undefined ? onChangeFocusOpt : function (section) {};
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold-primary";
  var titleSize = titleSizeOpt !== undefined ? titleSizeOpt : "base";
  var inline = inlineOpt !== undefined ? inlineOpt : false;
  var forceCollapsible = forceCollapsibleOpt !== undefined ? forceCollapsibleOpt : false;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var match$1 = Belt_Array.get(sections, 0);
  var initialActive = active !== undefined ? active : match$1 !== undefined ? match$1.id : "";
  var match$2 = React.useState(function () {
    return initialActive;
  });
  var setActive = match$2[1];
  var active$1 = match$2[0];
  React.useEffect(function () {
    Curry._1(setActive, function (param) {
      return initialActive;
    });
  }, [id]);
  var sections$1 = Belt_Array.mapWithIndex(sections, function (index, section) {
    var key = section.id + (section.collapsible ? "-" + id : "");
    var onExpand = function (param) {
      Curry._1(setActive, function (param) {
        return section.id;
      });
      Curry._1(onChangeFocus, section.id);
      Curry.app(trackEvent, [{
        NAME: "Clicked PDP Section Open",
        VAL: section.id
      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    };
    var onCollapse = function (param) {
      Curry._1(setActive, function (param) {
        return "";
      });
      Curry._1(onChangeFocus, "");
      Curry.app(trackEvent, [{
        NAME: "Clicked PDP Section Closed",
        VAL: section.id
      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    };
    return React.createElement(Accordion$Section, {
      index: index,
      section: section,
      onExpand: onExpand,
      onCollapse: onCollapse,
      active: active$1,
      titleStyle: titleStyle,
      titleSize: titleSize,
      forceCollapsible: forceCollapsible,
      inline: inline,
      truncated: truncated,
      key: key
    });
  });
  return React.createElement("div", {
    className: Cn.make([CSS$Showside.prefix(Cn.make(["flex-grow", inline ? "flex flex-row justify-between gap-10" : ""])), className])
  }, sections$1);
}
Accordion.displayName = "Accordion";
var make = Accordion;
export { makeSection, fromDetailedSections, getTitleClass, Header, Section, make };
/* react Not a pure module */